import React, { useContext } from 'react';
export var LoadingStatusContext = /*#__PURE__*/React.createContext(null);
export default function useLoadingStatus(name) {
  var parent = useContext(LoadingStatusContext);

  if (name) {
    while (parent && parent.name !== name) {
      parent = parent.parent;
    }
  }

  if (!parent) {
    throw new Error(name ? "No LoadingStatus named \u201C".concat(name, "\u201D was found here. Did you render a <LoadingStatus name=\"").concat(name, "\"> ancestor?") : 'No LoadingStatus was found here. Did you render a <LoadingStatus> ancestor?');
  }

  return useContext(parent.Context);
}